<template>
	<web-view :src="src"></web-view>
</template>

<script>
	export default {
		data() {
			return {
				src: ''
			};
		},
		onLoad(option) {
			this.src= option.url
			console.log("=======================",this.src)
		}
	}
</script>

<style lang="scss">
	web-view {
		width: 100vw;
		height: 100vh;
	}
</style>